import { render } from "./SteerabilityAxis.vue?vue&type=template&id=1fb2cb0a&scoped=true&ts=true"
import script from "./SteerabilityAxis.vue?vue&type=script&lang=ts"
export * from "./SteerabilityAxis.vue?vue&type=script&lang=ts"

import "./SteerabilityAxis.vue?vue&type=style&index=0&id=1fb2cb0a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fb2cb0a"]])

export default __exports__